let env = process.env.NODE_ENV
const active = 'https://dxs.moe.gov.cn/hd/' // 大学生在线活动中心地址
// const active = 'http://172.19.200.49/' // 大学生在线活动中心地址pro
const acpath = 'front/'
// const acpath = 'manage/'
const host = env === 'development' ? 'http://localhost:3001/' : env === 'production' ? active + acpath : active + acpath
const serverRoot = env === 'development' ? '/front/' : env === 'production' ? active + acpath + 'front' : ''
const loginRoot = env === 'development' ? 'http://localhost:8080/' : env === 'production' ? active + acpath : active + acpath
const home = 'https://dxs.moe.gov.cn/zx/' // 大学生在线地址
const logoutlink = 'https://dxs.moe.gov.cn/zx/hd/dxszxhdbm/' // 退出之后的地址
const formatDate = (date, fmt) => {
  if (!date) return
  if (!(date instanceof Date)) {
    date = new Date(date)
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'H+': date.getHours()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length))
    }
  }
  return fmt
}
const gblen = (str) => {
  let len = 0
  for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
           len += 2
       } else {
           len++
       }
   }
  return len
}
let config = {
  env: env,
  host: host,
  serverRoot: serverRoot,
  formatDate: formatDate,
  gblen: gblen,
  loginRoot: loginRoot,
  home: home,
  active: active,
  logoutlink: logoutlink,
  errtext: '请稍后再试！'
}
export default config



// WEBPACK FOOTER //
// ./src/config/config.js